/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Per_Team_SemInputs */

const en_cp_per_team_sem = /** @type {(inputs: Cp_Per_Team_SemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/team/semester`)
};

const id_cp_per_team_sem = /** @type {(inputs: Cp_Per_Team_SemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/tim/semester`)
};

/**
* | output |
* | --- |
* | "/team/semester" |
*
* @param {Cp_Per_Team_SemInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_per_team_sem = /** @type {((inputs?: Cp_Per_Team_SemInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Per_Team_SemInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_per_team_sem(inputs)
	return en_cp_per_team_sem(inputs)
});